import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  BreadcrumbModule,
  EmptyStateModule,
  ModalModule,
  PaginatorModule,
  TableModule,
  StatusModule,
  IconModule,
  ThemingModule,
  ScrollbarModule,
  DropdownModule
} from '@michelin/theme';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { SiteSetupSearchComponent } from './components/site-setup-search/site-setup-search.component';
import { SiteSetupDetailsComponent } from './components/site-setup-details/site-setup-details.component';
import { ZoneSetupDetailsComponent } from './components/zone-setup-details/zone-setup-details.component';
import { PlantSetupSearchComponent } from './components/plant-setup-search/plant-setup-search.component';
import { PlantSetupDetailsComponent } from './components/plant-setup-details/plant-setup-details.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatTimepickerModule } from '@angular/material/timepicker';
import { DealerSetupComponent } from './components/dealer-setup/dealer-setup.component';
import { PreferredTreadsComponent } from '../product-data/components/preferred-treads/preferred-treads.component';
import { PreferredTreadsSetupComponent } from '../product-data/components/preferred-treads-setup/preferred-treads-setup.component';
import { ProductImportComponent } from './components/product-import/product-import.component';
import { POSComponent } from './components/point-of-sale/point-of-sale.component';
import { EmailSetupComponent } from './components/email-setup/email-setup.component';
import { SetupContainerComponent } from './components/setup-container/setup-container.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    SiteSetupDetailsComponent,
    SiteSetupSearchComponent,
    PlantSetupSearchComponent,
    PlantSetupDetailsComponent,
    ProductImportComponent,
    SetupContainerComponent,
    POSComponent,
    DealerSetupComponent,
    PreferredTreadsComponent,
    PreferredTreadsSetupComponent,
    EmailSetupComponent,
    ZoneSetupDetailsComponent
  ],
  exports: [
    SiteSetupDetailsComponent,
    SiteSetupSearchComponent,
    PlantSetupSearchComponent,
    PlantSetupDetailsComponent,
    ProductImportComponent,
    SetupContainerComponent,
    POSComponent,
    DealerSetupComponent,
    PreferredTreadsComponent,
    PreferredTreadsSetupComponent,
    ZoneSetupDetailsComponent,
    EmailSetupComponent
  ],
  imports: [
    TableModule,
    BreadcrumbModule,
    EmptyStateModule,
    PaginatorModule,
    CommonModule,
    ModalModule,
    StatusModule,
    IconModule,
    ThemingModule,
    FormsModule,
    ReactiveFormsModule,
    ScrollbarModule,
    DropdownModule,
    MatTimepickerModule,
    SharedModule,
    DragDropModule,
    MatTabsModule,
    MatMenuModule,
    MatIconModule,
    RouterModule
  ]
})
export class SetupScreensModule {}
